const NavigationMenu = {
  Favorite: "0127f540-6e1e-48b3-a161-a9865c29e279"
};
export {
  NavigationMenu
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTmF2aWdhdGlvbk1lbnUuanMiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zdGFudHMvTmF2aWdhdGlvbk1lbnUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IE5hdmlnYXRpb25NZW51ID0ge1xuICAgIEZhdm9yaXRlOiBcIjAxMjdmNTQwLTZlMWUtNDhiMy1hMTYxLWE5ODY1YzI5ZTI3OVwiXG59O1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFPLE1BQU0saUJBQWlCO0FBQUEsRUFDMUIsVUFBVTtBQUNkOyJ9
